(function() { window.GUID_cd562069_c0e7_46a2_b748_c5c474fb9dfc = { getGuid: function() { return "cd562069-c0e7-46a2-b748-c5c474fb9dfc"; } }; })();
var PlayerStats;
(function (PlayerStats) {
    var desktop;
    (function (desktop) {
        $(function () {
            $('.CSDropDownCheckboxes').CSDropDownCheckboxes();
            BindElements();
        });
        function BindElements() {
            var btnShowTeams = $('#BtnShowTeams');
            var btnShowHistory = $('#BtnShowHistory');
            var btnEmbedStats = $('#BtnEmbedStats');
            var btnLinkFullScreenStats = $('#BtnLinkFullScreen');
            var divPlayerCard = $('#PlayerCard');
            var playerCard = $('.PlayerCard', divPlayerCard);
            var messageMiddleCard = $('.MessageMiddleCard', divPlayerCard);
            var pubsRotator = $('#PubsRotator');
            var btnAddToAssociation = $('#BtnAddToAssociation');
            var btnMergePlayers = $('#BtnMergePlayers');
            var btnSendMergePlayersRequest = $('#BtnSendMergePlayersRequest');
            var btnAverageHistory = $('#BtnAverageHistory');
            var btnLeagueStats = $('#BtnLeagueStats');
            var btnTournamentPage = $('#BtnTournamentPage');
            var btnUpdateEncounterStatSG = $('#BtnUpdateEncounterStatSG');
            let gridViewPlayerStatsUI = $('#GridViewPlayerStats');
            let gridViewPlayerStats = gridViewPlayerStatsUI.data('context');
            var btnShowGameHistory = $('#BtnShowGameHistory');
            var btnRatingHistory = $('#BtnRatingHistory');
            var btnChangeStartRating = $('#BtnChangeStartRating');
            let autoSearchPlayers = $('#autocompletePlayerId');
            $('#GridViewPlayerYearHistory').controlIsLoaded(function (gridView) {
                var gridViewTournamentsHistory = gridView;
                RefreshButtonsPlayerYearHistory();
            });
            CS.body.on('Refreshed', '#GridViewPlayerStats', function (e, gridView) {
                gridViewPlayerStats = gridView;
            });
            btnShowGameHistory.on('click', 'a', function (e) {
                e.preventDefault();
                var data = {
                    entityBaseId: $("#PlayerIds").val()
                };
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "",
                    Url: CSParameters.RUrl + 'CSRStartingRate/ShowGameHistory',
                    Data: data,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                });
            });
            btnRatingHistory.on('click', 'a', function (e) {
                e.preventDefault();
                var data = {
                    entityBaseId: $("#PlayerIds").val()
                };
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "",
                    Url: CSParameters.RUrl + 'CSRStartingRate/ShowRatingHistory',
                    Data: data,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                });
            });
            btnChangeStartRating.on('click', 'a', function (e) {
                e.preventDefault();
                var data = {
                    playerIds: $("#PlayerIds").val()
                };
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "StartRatingInputBox",
                    Url: CSParameters.RUrl + 'CSRStartingRate/StartRatingInputBox/' + CSParameters.SportEventId,
                    Data: data,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
                });
            });
            let gridViewPlayerYearHistoryUI = $('#GridViewPlayerYearHistory');
            let gridViewPlayerYearHistory = gridViewPlayerYearHistoryUI.data('context');
            let gridViewPlayerTournamentHistoryUI = $('#GridViewPlayerTournamentHistory');
            let gridViewPlayerTournamentHistory = gridViewPlayerTournamentHistoryUI.data('context');
            CS.body.on('Refreshed', '#GridViewPlayerYearHistory', function (e, gridView) {
                gridViewPlayerYearHistory = gridView;
            });
            CS.body.on('Refreshed', '#GridViewPlayerTournamentHistory', function (e, gridView) {
                gridViewPlayerTournamentHistory = gridView;
                RefreshButtonsPlayerYearHistory();
            });
            if (gridViewPlayerYearHistory != null) {
                gridViewPlayerYearHistory.SelectionChange = function () {
                    if (gridViewPlayerYearHistory.SelectedRows.length == 1) {
                        btnLeagueStats.removeClass('IsDisabled');
                    }
                    else {
                        btnLeagueStats.addClass('IsDisabled');
                    }
                };
            }
            if (gridViewPlayerTournamentHistory != null) {
                gridViewPlayerTournamentHistory.SelectionChange = function () {
                    if (gridViewPlayerTournamentHistory.SelectedRows.length == 1) {
                        btnTournamentPage.removeClass('IsDisabled');
                    }
                    else {
                        btnTournamentPage.addClass('IsDisabled');
                    }
                };
            }
            var btnRefresh = $('#BtnRefresh');
            btnRefresh.off('click');
            btnRefresh.on('click', function (e) {
                e.preventDefault();
                if (gridViewPlayerYearHistory != null) {
                    RefreshTwoGridsPlayerYearHistory();
                }
                else {
                    gridViewPlayerStats.RefreshGridData();
                }
            });
            btnMergePlayers.off('click');
            btnSendMergePlayersRequest.off('click');
            btnAddToAssociation.off('click');
            btnMergePlayers.off('click');
            btnShowTeams.off('click');
            btnShowHistory.off('click');
            btnAverageHistory.off('click');
            btnLeagueStats.off('click');
            btnTournamentPage.off('click');
            btnUpdateEncounterStatSG.off('click');
            btnTournamentPage.on('click', 'a', function (e) {
                e.preventDefault();
                var split = gridViewPlayerTournamentHistory.GetSelectedRowIds().split('_');
                var playerId = split[0];
                var eventId = split[2];
                if (playerId != undefined) {
                    var data = {
                        playerId: playerId
                    };
                    var reportParam = "?callFromHomePage=True&searchtype=Entity&entityId=" + data.playerId;
                    var url = CSParameters.RUrl + "GeneralSearch/Index/" + eventId + reportParam;
                    window.open(url, "_blank");
                }
            });
            btnLeagueStats.on('click', 'a', function (e) {
                e.preventDefault();
                var split = gridViewPlayerYearHistory.GetSelectedRowIds().split('_');
                var eventId = split[0];
                var playerId = split[1];
                var statGroupId = split[2];
                if (playerId != undefined) {
                    var data = {
                        playerId: playerId,
                        statGroupId: statGroupId
                    };
                    var reportParam = "?entityBaseId=" + data.playerId + "&statGroupId=" + data.statGroupId;
                    var url = CSParameters.RUrl + "PlayerStats/Index/" + eventId + reportParam;
                    window.open(url, "_blank");
                }
            });
            if (gridViewPlayerStats != null) {
                gridViewPlayerStats.SelectionChange = function () {
                    if (this.SelectedRows.length > 0) {
                        var split = this.GetSelectedRowIds().split('_');
                        var playerId = split[1];
                        if (playerCard.length > 0) {
                            var playerCardUrl = CSParameters.RUrl + "PlayerCard/" + CSParameters.SportEventId + "/" + $("#SelectedStatGroupId").control().GetSelectedItemValue("value") + "/" + playerId + "/55/";
                            playerCard[0].src = playerCardUrl;
                            messageMiddleCard.html('Loading...');
                            playerCard.show();
                            messageMiddleCard.show();
                        }
                        if (this.SelectedRows.length == 1) {
                            btnShowTeams.removeClass('IsDisabled');
                            btnShowHistory.removeClass('IsDisabled');
                            btnAverageHistory.removeClass('IsDisabled');
                        }
                        else {
                            btnShowHistory.addClass('IsDisabled');
                            btnShowTeams.addClass('IsDisabled');
                            btnAverageHistory.addClass('IsDisabled');
                        }
                    }
                    else {
                        if (playerCard.length > 0) {
                            playerCard.hide();
                            messageMiddleCard.hide();
                        }
                        btnShowTeams.addClass('IsDisabled');
                        btnShowHistory.addClass('IsDisabled');
                        btnAverageHistory.addClass('IsDisabled');
                    }
                };
            }
            btnUpdateEncounterStatSG.on('click', 'a', function (e) {
                e.preventDefault();
                let data = {};
                var statGroupId = $("#SelectedStatGroupId").control().GetSelectedItemValue("value");
                data.statgroupId = statGroupId;
                CompuSport.Controls.Popup.ShowConfirmDialogV2('', JSRess.AreYouSure, function () {
                    CompuSport.Ajax.Post(CSParameters.RUrl + "StatModelEditor/UpdateEncounterStat/" + CSParameters.SportEventId, data, function (queryResult) {
                        gridViewPlayerStats.RefreshGridData();
                    });
                });
            });
            var flowBlockNotes = $('#FlowBlockNotes');
            if (flowBlockNotes.length > 0) {
                //$("#SelectedStatGroupId").SelectionChange = function () {
                $("#SelectedStatGroupId").controlIsLoaded(function (SelectedStatGroupId) {
                    SelectedStatGroupId.SelectionChange = function (dropdown) {
                        if (dropdown.GetSelectedItemValue("value") != null) {
                            var data = {
                                statGroupId: dropdown.GetSelectedItemValue("value")
                            };
                            CompuSport.Ajax.Get(CSParameters.RUrl + "PlayerStats/GetFlowBlockNote/" + CSParameters.SportEventId, data, function (queryResult) {
                                $('#FlowBlockNotes')[0].innerText = queryResult;
                            });
                        }
                    };
                });
            }
            if (pubsRotator.length > 0) {
                pubsRotator.fadeIn(1000);
                document.PubsRotator.Cycle();
            }
            btnShowTeams.on('click', 'a', function (e) {
                e.preventDefault();
                var split = gridViewPlayerStats.GetSelectedRowIds().split('_');
                var playerId = split[1];
                if (playerId != undefined) {
                    let popup = new CompuSport.Controls.Popup();
                    popup.GetAndShow({
                        PopupId: "",
                        Url: CSParameters.RUrl + 'PlayerStats/ShowTeams/' + CSParameters.SportEventId + '?playerId=' + playerId,
                        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                    });
                    //ShowFormPopup(CSParameters.RUrl + 'PlayerStats/ShowTeams/' + CSParameters.SportEventId + '?playerId=' + playerId, null);
                }
            });
            btnShowHistory.on('click', 'a', function (e) {
                e.preventDefault();
                var split = gridViewPlayerStats.GetSelectedRowIds().split('_');
                var playerId = split[1];
                var statGroupId = $("#SelectedStatGroupId").control().GetSelectedItemValue("value");
                if (playerId != undefined) {
                    let popup = new CompuSport.Controls.Popup();
                    popup.GetAndShow({
                        PopupId: "",
                        Url: CSParameters.RUrl + 'PlayerStats/ShowPlayerHistory/' + CSParameters.SportEventId + '?playerId=' + playerId + '&selectedStatGroupId=' + statGroupId,
                        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                    });
                    //ShowFormPopup(CSParameters.RUrl + 'PlayerStats/ShowPlayerHistory/' + CSParameters.SportEventId + '?playerId=' + playerId, null);
                }
            });
            btnAverageHistory.on('click', 'a', function (e) {
                e.preventDefault();
                var split = gridViewPlayerStats.GetSelectedRowIds().split('_');
                var playerId = split[1];
                var statGroupId = $("#SelectedStatGroupId").control().GetSelectedItemValue("value");
                if (playerId != undefined) {
                    var data = {
                        playerId: playerId,
                        statGroupId: statGroupId
                    };
                    var reportParam = "?entityBaseId=" + data.playerId + "&statGroupId=" + data.statGroupId;
                    var url = CSParameters.RUrl + "PlayerStats/ExportAverageDetail/" + CSParameters.SportEventId + reportParam;
                    window.location.replace(url);
                    CS.win.trigger("downloadfinished");
                }
            });
            btnAddToAssociation.on('click', 'a', function (e) {
                e.preventDefault();
                var data = {
                    Post: true,
                    personids: $("#PlayerIds").val()
                };
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "",
                    Url: CSParameters.RUrl + 'PlayerStats/AddToAssociation/' + CSParameters.SportEventId,
                    Data: data,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
                });
            });
            btnLinkFullScreenStats.on('click', 'a', function (e) {
                e.preventDefault();
                ShowEmbeddedStatsPopupInfo(true);
            });
            btnEmbedStats.on('click', 'a', function (e) {
                e.preventDefault();
                ShowEmbeddedStatsPopupInfo(false);
            });
            autoSearchPlayers.on('CSChange', function (e, autocomplete) {
                //CS.on('CSChange', '#autocompletePlayerId', function (e, autocomplete) {
                if (autocomplete.val() != "0" && autocomplete.val() != "") {
                    var item = autocomplete.SelectedItem.value;
                    autocomplete.ClearValue();
                    var otherPlayerIds = "";
                    var otherPlayerIdAndNames = "";
                    var htmltoadd = "";
                    /*obtenir les ids des joueurs linkés.*/
                    var data = {
                        entitybaseIds: item.id
                    };
                    if ($("#PlayerIds").val() == "") {
                        $("#PlayerIds").val(item.id);
                    }
                    else {
                        var pid = $("#PlayerIds").val();
                        pid = pid + "," + item.id;
                        $("#PlayerIds").val(pid);
                    }
                    CompuSport.Ajax.Post(CSParameters.BaseUrl + "PlayerStats/GetLinkedPlayerId/" + CSParameters.SportEventId, data, function (result) {
                        otherPlayerIdAndNames = result.otherIds;
                        htmltoadd = result.htmlitemToAdd;
                        if (otherPlayerIdAndNames != "") {
                            var pid = $("#PlayerIds").val();
                            var otherIdSplit = otherPlayerIdAndNames.split(',');
                            for (let i = 0; i < otherIdSplit.length; i++) {
                                let idAndName = otherIdSplit[i].split(';');
                                let ieb = parseInt(idAndName[0]);
                                pid = pid + "," + ieb;
                            }
                            $("#PlayerIds").val(pid);
                            autoSearchPlayers.data('context').AutoComplete.autocomplete("search", autocomplete.beforeSelectionText);
                        }
                        //var playerBox = $('<div class="PlayerYearHistoryBox" data-tooltip="' + item.id + '" data-id="' + item.id + '"><div class="RemoveButton">X</div>' + item.label + '</div>');
                        //var playerBox = $('<div class="PlayerYearHistoryBox" data-tooltip="' + item.id + '" data-id="' + item.id + '"><div class="RemoveButton">X</div><div class= "PlayerName">' + item.label + '<img class="PlayerEdit" src="../../Images/GridView/Edit.png"/></div></div>');
                        $('#HistoryPlayers').append(htmltoadd);
                        let plrids = $("#PlayerIds").val();
                        var btnclear = $(".ClearPlayerYearHistoryBox");
                        if (plrids != "" && plrids.split(',').length >= 1 && btnclear.length == 0) {
                            var ClearButton = $('<div class="ClearPlayerYearHistoryBox"><div class="ClearSearch">Clear</div></div>');
                            $('#HistoryPlayers').prepend(ClearButton);
                        }
                        else {
                        }
                        RefreshTwoGridsPlayerYearHistory();
                    });
                }
            });
            $('#HistoryPlayers').on('click', '.RemoveButton', function () {
                var playerBox = $(this).parent();
                playerBox.remove();
                RefreshTwoGridsPlayerYearHistory();
                let plrids = $("#PlayerIds").val();
                if (plrids != "" && plrids.split(',').length == 1) {
                    var clearPlayerBoxes = $('#HistoryPlayers').find('.ClearPlayerYearHistoryBox');
                    clearPlayerBoxes.remove();
                }
            });
            $('#HistoryPlayers').on('click', '.ClearSearch', function () {
                ClearSelectionPlayers();
            });
            function RefreshButtonsPlayerYearHistory() {
                let plrids = $("#PlayerIds").val();
                if (plrids != "") {
                    btnAddToAssociation.removeClass('IsDisabled');
                    btnChangeStartRating.removeClass('IsDisabled');
                    if (plrids.split(',').length == 1) {
                        btnShowGameHistory.removeClass('IsDisabled');
                        btnRatingHistory.removeClass('IsDisabled');
                    }
                    else {
                        btnShowGameHistory.addClass('IsDisabled');
                        btnRatingHistory.addClass('IsDisabled');
                    }
                    if (plrids.split(',').length == 2) {
                        btnMergePlayers.removeClass('IsDisabled');
                    }
                    else {
                        btnMergePlayers.addClass('IsDisabled');
                    }
                    if (plrids.split(',').length >= 2) {
                        btnSendMergePlayersRequest.removeClass('IsDisabled');
                    }
                    else {
                        btnSendMergePlayersRequest.addClass('IsDisabled');
                    }
                }
                else {
                    btnAddToAssociation.addClass('IsDisabled');
                    btnMergePlayers.addClass('IsDisabled');
                    btnSendMergePlayersRequest.addClass('IsDisabled');
                    btnShowGameHistory.addClass('IsDisabled');
                    btnChangeStartRating.addClass('IsDisabled');
                    btnRatingHistory.addClass('IsDisabled');
                }
            }
            let removePlayerTimer = null;
            function RefreshTwoGridsPlayerYearHistory() {
                $('#PlayerIds').val(GetPlayerBoxesIds());
                removePlayerTimer = CS.LagLocal(removePlayerTimer, 500, function () {
                    gridViewPlayerYearHistory.RefreshGridData();
                    gridViewPlayerTournamentHistory.RefreshGridData();
                });
            }
            function GetPlayerBoxesIds() {
                var playerBoxes = $('#HistoryPlayers').find('.PlayerYearHistoryBox');
                let playerIds = "";
                $.each(playerBoxes, function () {
                    var playerBox = $(this);
                    var id = playerBox.data('id');
                    playerIds += "," + id;
                });
                return playerIds.substr(1);
            }
            function ClearSelectionPlayers() {
                $("#PlayerIds").val("");
                $('#HistoryPlayers')[0].innerText = "";
                RefreshTwoGridsPlayerYearHistory();
            }
            function ShowEmbeddedStatsPopupInfo(justHyperlink) {
                var data = {
                    statGroupId: $("#SelectedStatGroupId").control().GetSelectedItemValue("value"),
                    justHyperlink: justHyperlink
                };
                CompuSport.Ajax.Get(CSParameters.BaseUrl + "PlayerStats/GetStatsEmbbededString/" + CSParameters.SportEventId, data, function (result) {
                    CompuSport.Controls.Popup.ShowWarningDialog(result);
                });
            }
            btnMergePlayers.on('click', 'a', function (e) {
                e.preventDefault();
                var data = {
                    Post: true,
                    personids: $("#PlayerIds").val()
                };
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "",
                    Url: CSParameters.RUrl + 'PlayerOfAssociation/MergePlayers/' + CSParameters.SportEventId,
                    Data: data,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
                });
                popup.OnPosted = function (response) {
                    if (response.messages != undefined && response.messages != '') {
                        alert(response.messages);
                        /*obtenir les nouveaux ids.*/
                        window.location.assign(CSParameters.RUrl + 'PlayerStats/PlayerYearHistory/' + CSParameters.SportEventId);
                    }
                };
            });
            btnSendMergePlayersRequest.on('click', 'a', function (e) {
                e.preventDefault();
                var data = {
                    playerIds: $("#PlayerIds").val(),
                    notes: ""
                };
                CompuSport.Controls.Popup.ShowConfirmDialogV2('', "<div>Enter reason or special notes. Example: the correct spelling or the right lastname to use etc. </div><br><textarea cols='40' rows='8' class='CSDefault' type='text' id='mergenotes'/>", function (popup) {
                    var text = $('#mergenotes', popup.Content).val();
                    data.notes = text;
                    //call ajax
                    CompuSport.Ajax.Post(CSParameters.RUrl + "PlayerStats/SendMergePlayersRequest/" + CSParameters.SportEventId, data, function (queryResult) {
                        ClearSelectionPlayers();
                        if (queryResult != "") {
                            CompuSport.Controls.Popup.ShowWarningDialog(queryResult);
                        }
                    });
                });
            });
        }
        desktop.BindElements = BindElements;
    })(desktop = PlayerStats.desktop || (PlayerStats.desktop = {}));
})(PlayerStats || (PlayerStats = {}));

//# sourceMappingURL=PlayerStats.js.map
